import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { GuestOrderCheckoutCommandResult, GuestOrderDto } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IGuestOrderApiService {

  abstract guestOrderCheckout(guestOrder?: GuestOrderDto | undefined): Observable<GuestOrderCheckoutCommandResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IGuestOrderApiServiceToken = new InjectionToken<IGuestOrderApiService>('IGuestOrderApiServiceToken');
